import { render } from "./WindChart.vue?vue&type=template&id=80fc82b6"
import script from "./WindChart.vue?vue&type=script&lang=js"
export * from "./WindChart.vue?vue&type=script&lang=js"

import "./WindChart.vue?vue&type=style&index=0&id=80fc82b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__